export const wizardTermsAndConditions = [
  {
    tagType: 'text',
    tagText:
      'We respect your privacy and want to make you aware of a few things.',
  },
  {
    tagType: 'bold',
    tagText: 'By clicking Agree and See Offers',
  },
  {
    tagType: 'text',
    tagText: 'below I am providing my',
  },
  {
    tagType: 'bold',
    tagText: 'ESIGN',
  },
  {
    tagType: 'text',
    tagText:
      'signature and express written consent agreement to permit the company, or companies,',
  },
  {
    tagType: 'checkbox',
    inputName: 'One',
    inputId: 'checkboxamOne',
    ngInputName: true,
  },
  {
    tagType: 'text',
    tagText: 'AmONE',
  },
  {
    tagType: 'checkbox',
    inputName: 'Ml',
    inputId: 'checkboxamMl',
    ngInputName: true,
  },
  {
    tagType: 'text',
    tagText:
      'ML Enterprise Inc. to contact me at the number provided below for',
  },
  {
    tagType: 'text',
    tagText: 'including through the use of',
  },
  {
    tagType: 'bold',
    tagText: 'automated technology.',
  },
  {
    tagType: 'br',
  },
  {
    tagType: 'bold',
    tagText: 'SMS/MMS messages, AI generative voice,',
  },
  {
    tagType: 'text',
    tagText:
      'and prerecorded and/or artificial voice messages and I am providing written consent under the FCRA for Pastime Live Inc.',
  },
  {
    tagType: 'link',
    tagText: '(“LoansGenerator.com”)',
    tagLink: '/',
  },
  {
    tagType: 'text',
    tagText: 'and',
  },
  {
    tagType: 'link',
    tagText: 'its partners',
    tagLink: '/credit-authorization-agreement',
  },
  {
    tagType: 'text',
    tagText:
      'to obtain consumer report information from my credit profile. I acknowledge that my consent does not require me to purchase any products or services from them. Its entirely your choice. Please see our',
  },
  {
    tagType: 'link',
    tagText: '“Privacy Policy”',
    tagLink: '/privacy-policy',
  },
  {
    tagType: 'text',
    tagText: 'and our',
  },
  {
    tagType: 'link',
    tagText: '“Terms of Use”',
    tagLink: '/terms-of-use',
  },
];
